<a *ngIf="breadcrumb.url!=''" [routerLink]="breadcrumb.url">{{breadcrumb.urlName}}</a>
<span *ngIf="breadcrumb.url==''">{{breadcrumb.urlName}}</span>